import React from 'react'
import { Box, useTheme, useMediaQuery } from '@mui/material'
import Stepper from './Stepper'

const RecepcionHojaDeVida = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <div>
      <Box px={isMobile ? 2 : 20}>
        <Stepper />
      </Box>
    </div>
  )
}

export default RecepcionHojaDeVida